// TODO: replace string literals with variables - (phyoh)
import { getZrmListingInfo, getZrmUserInfo } from '@zg-rentals/clickstream';
import { trackEvent } from '../../../client/analytics';

import type { ZrmClickstreamListing, ZrmClickstreamUser } from '@zg-rentals/clickstream';

const EVENT_IDS = {
  CREATE_A_LEASE: '2849',
  VIEW_ALL_LEASES: '3535',
  GET_STARTED: '2848',
  VIEW_GENERATED_LEASE: '8119',
} as const;

// https://dataportal.zillowgroup.net/event-registry/3535
const ViewAllLeases = ({ user }: { user: ZrmClickstreamUser }) =>
  trackEvent.user({
    envelope: {
      event_template_id: '168',
      event_template_version_id: '1',
      event_type_id: EVENT_IDS.VIEW_ALL_LEASES,
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: 'sense_of_home | manage_tenants',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'view_all_leases',
    },
    semantic: {
      semantic_event_nm: 'view_all_leases',
      topic_tag_txt: ['zrm_leases'],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/2849
const CreateALease = ({ user }: { user: ZrmClickstreamUser }) =>
  trackEvent.user({
    envelope: {
      event_template_id: '168',
      event_template_version_id: '1',
      event_type_id: EVENT_IDS.CREATE_A_LEASE,
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: 'sense_of_home | manage_tenants',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'create_a_lease',
    },
    semantic: {
      semantic_event_nm: 'start_lease',
      topic_tag_txt: ['zrm_leases'],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/2848
const GetStarted = ({ user }: { user: ZrmClickstreamUser }) =>
  trackEvent.user({
    envelope: {
      event_template_id: '168',
      event_template_version_id: '1',
      event_type_id: EVENT_IDS.GET_STARTED,
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: 'sense_of_home | manage_tenants',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'get_started_lease',
    },
    semantic: {
      semantic_event_nm: 'start_lease',
      topic_tag_txt: ['zrm_leases'],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/8119
const ViewGeneratedLease = ({
  currentProperty,
  user,
}: {
  currentProperty: ZrmClickstreamListing;
  user: ZrmClickstreamUser;
}) =>
  trackEvent.listingUser({
    envelope: {
      event_template_id: '283',
      event_template_version_id: '1',
      event_type_id: EVENT_IDS.VIEW_GENERATED_LEASE,
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: 'zrm_property_overview',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'view_lease',
    },
    semantic: {
      semantic_event_nm: 'click_view_lease',
      topic_tag_txt: [],
    },
    ...getZrmListingInfo(currentProperty),
    ...getZrmUserInfo(user),
  });

const ManageTenantsCSEvents = {
  CreateALease,
  ViewAllLeases,
  GetStarted,
  ViewGeneratedLease,
};

// Clickstream visualizer data-eventid attributes
CreateALease.data_event_id = EVENT_IDS.CREATE_A_LEASE;
ViewAllLeases.data_event_id = EVENT_IDS.VIEW_ALL_LEASES;
GetStarted.data_event_id = EVENT_IDS.GET_STARTED;
ViewGeneratedLease.data_event_id = EVENT_IDS.VIEW_GENERATED_LEASE;

export default ManageTenantsCSEvents;
